import { makeStyles } from '@material-ui/core/styles';

export const openedWidth = '16rem';
export const closedWidth = '1rem';

export const textDefault = (theme) => ({
  color: theme.palette.text.primary,
  fontSize: '1.125rem',
});

const useStyles = makeStyles((theme) => ({
  content: {
    ...textDefault(theme),
    marginTop: '1rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '2rem',
    overflow: 'auto',
    height: '36.5rem',
    padding: '0 0.5rem',
  },
  containerBottom: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  details: {
    display: 'flex',
    gap: '0.5rem',
    justifyContent: 'space-between',
    marginTop: '1.5rem',
    marginBottom: '2rem',
  },
  text: {
    marginTop: '0.5rem',
    fontWeight: 400,
    ...textDefault(theme),
  },
  label: {
    fontSize: '0.75rem',
    color: theme.palette.text.primary,
  },
  title: {
    fontWeight: 600,
    textDecoration: 'underline',
    ...textDefault(theme),
  },
  treeView: {
    overflowY: 'auto',
  },
  menu: {
    display: 'flex',
    flexDirection: 'column',
    transition: 'min-width .1s',
    zIndex: 1,
    marginRight: '1rem',
  },
  uncoveredAreaToggle: {
    marginLeft: '1.4rem',
    marginRight: '-0.45rem',
  },
  uncoveredAreasLabel: {
    width: '100%',
  },
  loaderContainer: {
    height: '40rem',
    width: '100%',
  },
}));

export default useStyles;
